<script lang="ts" setup>
  import { computed } from 'vue';
  import CuratedDeals from "@/components/views/rewards/CuratedDeals.vue";
  import SimpleModal from '@/components/modals/SimpleModal.vue';
  import { useCardsStore } from '@/stores/cards';

  const cardsStore = useCardsStore();
  const showModal = computed(() => cardsStore.showCardExistsModal);

  const close = () => {
    cardsStore.showCardExistsModal = false;
  }

  function handleModelUpdate(value: boolean) {
    value ? cardsStore.showCardExistsModal = true : close();
  }

</script>

<template>
  <SimpleModal
    :model-value="showModal"
    @update:model-value="handleModelUpdate"
    :compact=true
    width="800"
  >
  <div class="content">
    <div class="card-link-success">
      <div class="title">
        <div class="t-title-1 t-bold">
          {{ $t('modal.link.card.cardexists.title') }}
        </div>
        <div class="t-body-1 mt-4">
          {{ $t('modal.link.card.cardexists.content') }}
        </div>
      </div>
      <CuratedDeals :show-title="false" style="width:100%;"/>
      <v-btn color="primary" class="card-link-description" @click="close">
        {{ $t('modal.link.card.success.cta') }}
      </v-btn>
    </div>
  </div>
  </SimpleModal>
</template>

<style scoped lang="scss">
  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px 0;
    text-align: center;
    min-height: 450px;
    height: 450px;

    .card-link-success {
      height: 100%;
      max-width: 900px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
    }

    @media screen and (max-width: breakpoint(md) - 1px) {
      .card-link-success {
        width: 100%;
      }
    }

  }
</style>
